import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { FlatTreeControl } from '@angular/cdk/tree';
import {
  MatTreeFlatDataSource,
  MatTreeFlattener,
} from '@angular/material/tree';
import {
  environment as ENV,
  environment,
} from '../../../../environments/environment';
import { MatDialog } from '@angular/material/dialog';
import { CodigoAsesorService } from '../../../services/codigo-asesor/codigo-asesor.service';
import { Router } from '@angular/router';
import { StorageService } from '../../../utils/util.storage.service';
import { UserLoggedResponse } from '../../../models/user';
import { AuthService } from '../../../services/security/auth.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { URL_MAP } from '../../../shared/urlMap';

interface MenuItem {
  etiqueta: string;
  link: string | null;
  tipoLink: string | null;
  opcionesPadre: MenuItem | null;
  acciones: any;
  icon: string;
  parameters: any;
  children?: MenuItem[];
}

interface ExampleFlatNode {
  expandable: boolean;
  name: string;
  icon: string;
  level: number;
  link: string | null;
}

@Component({
  selector: 'app-sidebar-menu',
  templateUrl: './sidebar-menu.component.html',
  styleUrls: ['./sidebar-menu.component.css'],
})
export class SidebarMenuComponent implements OnInit {
  @Input() menuData: MenuItem[] = [];
  loggedUser: UserLoggedResponse = new UserLoggedResponse();
  treeControl = new FlatTreeControl<ExampleFlatNode>(
    (node) => node.level,
    (node) => node.expandable
  );
  HOST_LINK_PAGO = ENV.HOST_LINK_PAGO;
  EXTERNAL = URL_MAP.EXTERNAL;
  version = URL_MAP.version;

  private _transformer = (node: MenuItem, level: number) => {
    return {
      expandable: !!node.children && node.children.length > 0,
      name: node.etiqueta,
      icon: node.icon,
      link: node.link,
      level: level,
    };
  };

  treeFlattener = new MatTreeFlattener(
    this._transformer,
    (node) => node.level,
    (node) => node.expandable,
    (node) => node.children
  );

  public menuDS = new MatTreeFlatDataSource(
    this.treeControl,
    this.treeFlattener
  );
  menu: { [key: string]: MenuItem } = {};
  logInfo: any;
  tipoRol: any;
  constructor(
    private authService: AuthService,
    private codigoAsesorService: CodigoAsesorService,
    private router: Router,
    private storageService: StorageService,
    private spinner: NgxSpinnerService
  ) { }

  async ngOnInit(): Promise<void> {
    this.logInfo = await this.authService.getAuthInfo();
    this.tipoRol = this.logInfo?.roles?.[0]?.nombreRol ?? '';
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['menuData']) {
      this.menuDS.data = this.menuData;
      console.log('menuData ->', this.menuData);
      this.buildMenu();
    }
  }

  private buildMenu() {
    // Construimos el menú
    this.menuData.forEach((item) => {
      if (item.opcionesPadre === null) {
        // Es un padre
        this.menu[item.etiqueta] = {
          ...item,
          icon: this.getIconName(item.etiqueta),
          children: [],
        };
      } else {
        // Es un hijo
        const parentLabel = item.opcionesPadre.etiqueta;
        if (this.menu[parentLabel]) {
          item.icon = '';
          this.menu[parentLabel].children!.push(item);
        } else {
          // Si el padre aún no existe en el menú
          this.menu[parentLabel] = {
            etiqueta: parentLabel,
            link: null,
            tipoLink: null,
            opcionesPadre: null,
            acciones: null,
            icon: this.getIconName(item.etiqueta),
            parameters: null,
            children: [item],
          };
        }
      }
    });
    const menuArray: MenuItem[] = Object.values(this.menu);
    this.menuDS.data = menuArray;
    console.log(menuArray);
  }

  getIconName(tag: string): string {
    var nameTag = 'error';
    switch (tag) {
      case 'CARNÉ DE USUARIOS':
        nameTag = 'carnet';
        break;
      case 'COTIZADOR':
        nameTag = 'cotizador';
        break;
      case 'PORTAFOLIO DE SOLUCIONES':
        nameTag = 'portafolio';
        break;
      case 'MI POBLACIÓN':
        nameTag = 'poblacion';
        break;
      case 'MIS COMISIONES':
        nameTag = 'comisiones';
        break;
      case 'LINK DE PAGO PRIMERA CUOTA':
        nameTag = 'link_pagos';
        break;
      case 'MIS AFILIACIONES':
        nameTag = 'afiliaciones';
        break;
      case 'MIS OPORTUNIDADES COMERCIALES':
        nameTag = 'oportunidad2';
        break;
      case 'AUTORIZACIONES':
        nameTag = 'autorizaciones';
        break;
      case 'MIS REFERIDOS':
        nameTag = 'referidos_icon';
        break;
      case 'MIS CERTIFICADOS':
        nameTag = 'certificados';
        break;
    }
    return nameTag;
  }

  encodeBase64(data: string): string {
    return btoa(encodeURIComponent(data));
  }

  openDialog(name: string) {
    this.spinner.show();

    const userCC: UserLoggedResponse = this.storageService.getItem('user');
    const cleanedInput = userCC?.document?.replace('.', '') || '';
    const [tipoId, numeroId] = cleanedInput.split(' ');
    const usuario = this.encodeBase64(numeroId);
    const password = this.encodeBase64(numeroId);
    const tipoRol = this.logInfo.roles[0].nombreRol;

    if (!numeroId) {
      this.spinner.hide();
      alert('No se encontró el documento del asesor');
      return;
    }

    if (name === 'Primera cuota' || name === 'Gestor de links') {
      this.codigoAsesorService.getCodigoAsesor(numeroId).subscribe({
        next: (idasesor) => {
          let url: string;

          if (name === 'Primera cuota') {
            url = `${this.HOST_LINK_PAGO}${this.EXTERNAL.LINKPAGO_PRIMERA_CUOTA}?strCodigoAsesor=${idasesor}&strTipoDocumento=${tipoId}&strUsuario=${usuario}&strContrasenia=${password}&strRol=${tipoRol}&desdeModal=true&header=false`;
            // url = `http://localhost/link-de-pagos/primeracuota/obtener-datos?strCodigoAsesor=${idasesor}&strUsuario=${usuario}&strContrasenia=${password}&strRol=${tipoRol}&desdeModal=true&header=false`;
            this.router.navigate(['/main/primera-cuota'], {
              queryParams: {
                urlIframe: url,
              },
            });
          } else {
            url = `${this.HOST_LINK_PAGO}${this.EXTERNAL.LINKPAGO_GESTOR}?strCodigoAsesor=${idasesor}&strNumeroDocumento=${numeroId}&strTipoDocumento=${tipoId}&strUsuario=${usuario}&strContrasenia=${password}&strRol=${tipoRol}&desdeModal=true&header=false`;
            // url = `http://localhost/link-de-pagos/gestorlinks/obtener-datos?strCodigoAsesor=${idasesor}&strUsuario=${usuario}&strContrasenia=${password}&strRol=${tipoRol}&desdeModal=true&header=false`;
            this.router.navigate(['/main/gestor-links'], {
              queryParams: {
                urlIframe: url,
              },
            });
          }

          this.spinner.hide();
        },
        error: (err) => {
          this.spinner.hide();
          console.error('Error obteniendo idasesor:', err);
          alert('Error al obtener el código del asesor.');
        },
      });
    } else if (name === 'Consulta Mis Oportunidades Comerciales') {
      if (tipoRol === 'Asesor Externo') {
        this.spinner.hide();
        this.router.navigate(['/main/oportunidades-comerciales-externos']);
        return;
      }

      if (tipoRol === 'Asesor Interno') {
        // Directamente redirigir sin abrir dialog
        this.spinner.hide();
        this.router.navigate(['/main/oportunidades-comerciales-internos']);
      }
    } else {
      this.spinner.hide();
      console.warn('Nombre no reconocido en openDialog:', name);
    }
  }

  hasChild = (_: number, node: ExampleFlatNode) => node.expandable;
}
